<script setup>
import { computed, getCurrentInstance, watch } from 'vue';
import { useAsyncState } from '@vueuse/core';
import FormControlCategoryTitle from '../../common/form-control/FormControlCategoryTitle.vue';

const props = defineProps({
    field: Object,
    item: Object
});

const { proxy } = getCurrentInstance();
const store = proxy.$store;

const { state: content, execute: fetchContent } = useAsyncState(
    () => store.dispatch('itemData/get', { tableName: 'content', id: props.item.contentId }),
    null
);

const { state: contentType, execute: fetchContentType } = useAsyncState(
    async () => {
        if (!content.value) return null;
        return store.dispatch('itemData/get', {
            tableName: 'templates_templates',
            id: content.value.contentType
        });
    },
    null,
    { immediate: false }
);

// Chains
watch(() => props.item.contentId, () => fetchContent(), { immediate: true });
watch(content, (val) => { if (val) fetchContentType(); });

const componentId = computed(() => contentType.value?.componentId);
const tableName = computed(() => {
    const targetId = props.item.fieldId === null ? componentId.value : props.field?.categoryComponentId;
    return store.state.components.items.find(o => o.id === targetId)?.tableName;
});
const itemId = computed(() => parseInt(props.item.value));
const show = computed(() => ['is associated to', 'is not associated to'].includes(props.item.operator));

const selectCategory = () => {
    const modalPromise = store.dispatch('modals/show', {
        componentName: 'SelectListModal',
        obj: {
            listingName: `${tableName.value}.${props.item.fieldId}`,
            selectedIds: itemId.value ? [itemId.value] : [],
            onSelect: (selectedIds) => {
                props.item.value = selectedIds.pop();
                modalPromise.then(obj => store.dispatch('modals/remove', obj.index));
            }
        }
    });
};
</script>

<template>
    <button
        v-if="show && tableName"
        class="btn btn-sm btn-light text-start"
        type="button"
        @click="selectCategory"
    >
        <span v-if="!item.value">select</span>
        <FormControlCategoryTitle v-if="itemId" :table-name="tableName" :id="itemId"/>
    </button>

    <small v-else-if="show && !componentId" class="text-danger form-text ms-2 mb-1 fst-italic small">
        Error: No collection targeted
    </small>
</template>